import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Helper
import { convert, getFixedValue } from '../../helpers/currencyConvertion';
class CurrencyConverter extends Component {

  static propTypes = {
    from: PropTypes.string,
    amount: PropTypes.number,
    base: PropTypes.string,
    rates: PropTypes.object,
    superSymbol: PropTypes.bool,
    className: PropTypes.string,
    toCurrency: PropTypes.string,
  };

  static defaultProps = {
    amount: 0,
    superSymbol: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      base: null,
      rates: null
    }
  }

  UNSAFE_componentWillMount() {
    const { base, rates } = this.props;
    if (base != undefined && rates != undefined) {
      this.setState({ base: base, rates: rates });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { base, rates } = nextProps;
    if (base != undefined && rates != undefined) {
      this.setState({ base: base, rates: rates });
    }
  }

  render() {
    const { from, amount, superSymbol, className, toCurrency } = this.props;
    const { base, rates } = this.state;

    let targetCurrency;
    let convertedAmount = amount;
    let fromCurrency = from || base;

    if (rates != null) {
      convertedAmount = getFixedValue(convert(base, rates, amount, fromCurrency, toCurrency));
    }

    if (toCurrency) {
      targetCurrency = toCurrency;
    } else {
      targetCurrency = base;
    }

    const isBOB = targetCurrency === 'BOB';
    const formatStyle = isBOB ? 'decimal' : 'currency';
    const formatCurrency = isBOB ? undefined : targetCurrency;

    const formattedNumber = new Intl.NumberFormat('en-US', {
      style: formatStyle,
      currency: formatCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: "symbol"
    }).format(convertedAmount).replace(/,/g, '.');

    return (
      <span className={className}>
        {isBOB && <>{'Bs '}</>}
        {formattedNumber}
        {
          superSymbol && !isBOB && <sup>{targetCurrency}</sup>
        }

      </span>
    )
  }
}

const mapState = (state) => ({
  base: state.currency.base,
  toCurrency: state.currency.to,
  rates: state.currency.rates,
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(CurrencyConverter);